<div class="avater">
  <div
    *ngIf="message.type === MessageType.Outbound"
    class="img-holder"
    (click)="toggleCollapsing(!collapsed)"
    [matTooltip]="toggleCollapsingTooltip"
    matTooltipPosition="below"
  >
    <img src="../assets/images/logo-sm.png" alt="" *ngIf="!isBot" />
    <svg-icon
      *ngIf="isBot"
      src="assets/images/icons/ai.svg"
      [svgStyle]="{ 'width.px': 25, color: '#4ca21b' }"
    ></svg-icon>
  </div>
  <span
    *ngIf="message.type === MessageType.Inbound || message.type === MessageType.Guest"
    class="avater-cst-magenta"
    (click)="toggleCollapsing(!collapsed)"
    [matTooltip]="toggleCollapsingTooltip"
    matTooltipPosition="below"
  >
    {{ guestName | capitalize | initials }}
  </span>
</div>
<div class="content flex-fill">
  <div class="d-flex box-title-holder" *ngIf="!isDraft">
    <div
      class="title"
      (click)="toggleCollapsing(!collapsed)"
      [matTooltip]="toggleCollapsingTooltip"
      matTooltipPosition="below"
    >
      <ng-container *ngIf="message.type === MessageType.Inbound">
        <span>
          {{ guestName | truncate: 25 }}
        </span>
        <span class="to">to</span>
        <span> Tokeet </span>
      </ng-container>
      <ng-container *ngIf="message.type === MessageType.Guest">
        <span>
          {{ guestName | truncate: 25 }}
        </span>
        <span class="to">to</span>
        <span> Tokeet </span>
      </ng-container>
      <ng-container *ngIf="message.type === MessageType.Outbound || message.type === MessageType.Draft">
        <span>
          {{ message.name || 'Unknown sender' | truncate: 25 }}
        </span>
        <span class="to">to</span>
        <span>
          {{ guestName | truncate: 25 }}
        </span>
      </ng-container>
      <message-sent-with
        [sentWith]="message.sentWith"
        platform="tokeet"
        class="d-inline-block ml-2"
      ></message-sent-with>
    </div>
    <div class="flex-fill"></div>
    <div class="icons-holder">
      <ng-content select="[actions]"></ng-content>
    </div>
  </div>

  <div *ngIf="collapsed" class="clearfix collapsed-content" (click)="toggleCollapsing(!collapsed)">
    <div [innerHtml]="message.messageTxt || message.messageHtml || 'Message collapsed.'"></div>
    <i class="fal fa-chevron-double-down"></i>
  </div>

  <ng-container *ngIf="!collapsed">
    <div
      *ngIf="(message.messageTxt && !message.messageHtml) || viewPlainText"
      class="clearfix white-box-content"
      [ngClass]="{ clickable: clickable }"
      (click)="bodyClick.emit()"
    >
      <div [innerHtml]="message.messageTxt"></div>
      <ng-container *ngTemplateOutlet="quote"></ng-container>
    </div>

    <div
      *ngIf="message.messageHtml && !viewPlainText"
      class="clearfix white-box-content"
      [ngClass]="{ clickable: clickable }"
      (click)="bodyClick.emit()"
    >
      <div class="message-content">
        <div [innerHtml]="message.sanitizedMsgHtml"></div>
        <ng-container *ngTemplateOutlet="quote"></ng-container>
        <ng-container *ngTemplateOutlet="attachments"></ng-container>
      </div>
      <div *ngIf="isDraft" class="draft-actions mt-2">
        <div>Not happy? <a href="javascript:;" (click)="onAIGenerate()">Generate another response</a></div>
        <a class="draft-action" matTooltip="Edit this message draft" (click)="onEditDraft(message)"
          ><i class="fa fa-pencil"></i
        ></a>
        <a class="draft-action" matTooltip="Send this message to guest" (click)="onSendDraft(message)"
          ><i class="fa fa-paper-plane"></i
        ></a>
        <a class="draft-action danger" matTooltip="Remove this message draft" (click)="onRemoveDraft(message)"
          ><i class="fa fa-trash"></i
        ></a>
      </div>
    </div>
    <div class="clearfix date-time" *ngIf="!isDraft">
      {{ message.receivedOn | epoch }}
    </div>
  </ng-container>

  <ng-template #quote>
    <div *ngIf="message.template === tokeetTemplates.TokeetQuoteTemplate">
      <h4>Your Quote</h4>
      <div></div>
      <table *ngIf="!inquiry?.bookingEngine">
        <tr>
          <th>Base Rate:</th>
          <td><span [innerHtml]="message.charge | tokeetCurrency: currencySymbol"></span></td>
        </tr>
        <tr>
          <th>Discounts & Fees:&nbsp;&nbsp;</th>
          <td><span [innerHtml]="message.discounts | tokeetCurrency: currencySymbol"></span></td>
        </tr>
        <tr>
          <th>Tax:</th>
          <td><span [innerHtml]="message.taxFee | tokeetCurrency: currencySymbol"></span></td>
        </tr>
        <tr class="quote-total">
          <th>Total Amount:</th>
          <td><span [innerHtml]="message.sum | tokeetCurrency: currencySymbol"></span></td>
        </tr>
      </table>
      <table *ngIf="inquiry?.bookingEngine">
        <tr>
          <th>Base Charge:&nbsp;&nbsp;</th>
          <td>
            <span [innerHtml]="inquiry?.bookingEngine?.extraBedroomsBase | tokeetCurrency: currencySymbol"></span>
          </td>
        </tr>
        <tr>
          <th>Additional Guests Fee:&nbsp;&nbsp;</th>
          <td><span [innerHtml]="inquiry?.bookingEngine?.extraGuests | tokeetCurrency: currencySymbol"></span></td>
        </tr>
        <tr *ngIf="!!inquiry?.bookingEngine?.extraBedrooms">
          <th>Additional Bedrooms Fee:&nbsp;&nbsp;</th>
          <td><span [innerHtml]="inquiry?.bookingEngine?.extraBedrooms | tokeetCurrency: currencySymbol"></span></td>
        </tr>
        <tr>
          <th>Discounts & Fees:&nbsp;&nbsp;</th>
          <td><span [innerHtml]="inquiry?.bookingEngine?.discountTotal | tokeetCurrency: currencySymbol"></span></td>
        </tr>
        <tr *ngFor="let fee of inquiry?.bookingEngine?.bookingFees">
          <th>{{ fee.name }}</th>
          <td><span [innerHtml]="fee.amount | tokeetCurrency: currencySymbol"></span></td>
        </tr>
        <tr>
          <th>Taxes:</th>
          <td><span [innerHtml]="inquiry?.bookingEngine?.taxTotal | tokeetCurrency: currencySymbol"></span></td>
        </tr>
        <tr class="quote-total">
          <th>Total:</th>
          <td><span [innerHtml]="inquiry?.bookingEngine?.total | tokeetCurrency: currencySymbol"></span></td>
        </tr>
      </table>
    </div>
  </ng-template>

  <ng-template #attachments>
    <ng-container *ngIf="!message.innerAttachments">
      <div *ngFor="let attachment of message.attachments">
        <a *ngIf="!attachment.path && !!attachment.url" [href]="attachment.url" target="_blank"
          >{{ attachment.name }}&nbsp;&nbsp;<i class="fal fa-paperclip"></i
        ></a>
        <a *ngIf="!!attachment.path && !attachment.url" (click)="onDownloadAttachment(attachment)"
          >{{ attachment.name }}&nbsp;&nbsp;<i class="fal fa-paperclip"></i
        ></a>
      </div>
    </ng-container>
  </ng-template>
</div>
